import { TinyColor } from '@ctrl/tinycolor';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';

interface IModuleTagProps {
	text: string;
	color: string;
}

const lighten = (tinyColor: TinyColor) => {
	let newColor = tinyColor;
	do {
		newColor = newColor.lighten(2);
	} while (newColor.getLuminance() < 0.85);
	return newColor;
};

/** Section label tag with a subtle colored background, black text, and a colored border. */
export const ModuleTag = ({ text, color }: IModuleTagProps) => {
	const dynamicStyles = React.useMemo(() => {
		const base = new TinyColor(color);
		return {
			backgroundColor: lighten(base).toHexString(),
			borderColor: base.toHexString(),
		};
	}, [color]);

	return (
		<span className={css(styles.tag)} style={dynamicStyles}>
			{text}
		</span>
	);
};

const styles = StyleSheet.create({
	tag: {
		borderRadius: 4,
		borderStyle: 'solid',
		borderWidth: 1,
		color: '#000',
		display: 'inline-block',
		fontSize: '0.625rem',
		fontWeight: 400,
		padding: '0.25rem 0.5rem',
		textTransform: 'uppercase',
	},
});
